<template>

  <div id="app">
    <navigation/>
    <div class="info warp">
      <div class="photo ">
        <img style="margin-top:20px" :src="user!=null?user.img:'/static/images/my_user.jpg'"/>
        <div class="name">用户名:{{user.userName!=null && user.userName!=''?user.userName:user.phone}}</div>
        <div class="clear_both"></div>
      </div>
      <div class="member fc3b3838">
        <div class="type">剩余监测作品数<span :style="user.number == 0 ?'color:red':'color:green'">{{user.number}}</span>次</div>
      </div>
      <div class="renew">
        <a style="color:green" href="./store">{{user.number == 0 ?'购买套餐':'继续购买'}}</a>
      </div>
      <div class="clear_both"></div>
    </div>
    <div class="main">
      <div class="layout warp">
        <div class="menu">
          <ul>
            <li :class="(iframeSrc=='searching' || iframeSrc == 'history')?'active':''" style="background-image:url(/static/images/i_1.png)"><a href="my?page=searching">我的报告</a></li>
            <li :class="(iframeSrc=='message')?'active':''" style="background-image:url(/static/images/i_2.png)"><a href="my?page=message">消息中心</a></li>
            <li :class="(iframeSrc=='auth')?'active':''" style="background-image:url(/static/images/i_3.png)"><a href="my?page=auth">实名认证</a></li>
            <li :class="(iframeSrc=='appointmentprocess')?'active':''" style="background-image:url(/static/images/i_4.png)"><a href="my?page=appointmentprocess">预约</a></li>
            <li :class="(iframeSrc=='feedback')?'active':''" style="background-image:url(/static/images/i_5.png)"><a href="my?page=feedback">意见反馈</a></li>
            <li :class="(iframeSrc=='OrderList')?'active':''" style="background-image:url(/static/images/i_5.png)"><a href="my?page=OrderList">我的消费</a></li>
            <li :class="(iframeSrc=='info')?'active':''" style="background-image:url(/static/images/i_6.png)"><a href="my?page=info">我的资料</a></li>
          </ul>
        </div>
        <div class="cnt">
          <iframe id="iframe" :src="iframeSrc"></iframe>
        </div>
      </div>
      
    </div>
    <el-dialog
      title="提示"
      :visible.sync="closeTaskDialog"
      width="30%"
    >
      <span>确实要介绍【{{closeTaskTitle}}】的任务吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeTaskDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<style scoped src="../../static/css/Common.css"></style>
<style scoped src="../../static/css/My.css"></style>

<script>
import Navigation from '@/components/area/Navigation.vue'
import {closeTask} from '@/service/allApi'
export default {
  data(){
    return {
      iframeSrc:"history",
      closeTaskDialog:false,
      closeTaskTitle:"",
      closeTaskId:0,
      user:null,
    }
  },
  created:function(){
    var that = this
    that.user =JSON.parse(localStorage.getItem("user"))
  },
  mounted(){
    const page = this.$route.query.page
    this.iframeSrc = page
    const that = this
    window.toUrl = function(url){
      window.location.href =  url
    }
    
    window.closeTask = that.closeTask
  },
  methods: {
    closeTask(taskId,title){
      this.closeTaskTitle = title
      this.closeTaskId = taskId
      this.closeTaskDialog = true
      
    },
    async confirmClose(){
      const options = {
        taskId:this.closeTaskId
      }
      
      const res = await closeTask(options)
      this.closeTaskDialog = false
      if(res.data.code == 100){
        this.$message.success("删除成功")
        document.getElementById("iframe").contentWindow.location.reload(true)
      }else{
        this.$message.error("删除失败")
      }
    }

  },
  components: {
        navigation: Navigation
    }
}
</script>


<style  scoped>

.head{
  height: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/My.vue